export const ConvertDate = (date, type, year, month, day) => {
  // Paramètre pour convertir la date au format français souhaité
  const options =
    type === "long"
      ? {
          weekday: "short",
          year: "numeric",
          month: "long",
          day: "numeric",
        }
      : type === "sansJour"
      ? {
          year: "numeric",
          month: "long",
          day: "numeric",
        }
      : {
          year: "numeric",
          month: "long",
          day: "numeric",
        };

  // Parser la date au format français DD/MM/YYYY
  const [dayPart, monthPart, yearPart] = date.split('/');
  const dateConvert = new Date(yearPart, monthPart - 1, dayPart).toLocaleDateString("fr-FR", options);
  return dateConvert;
};
